import { createSlice } from "@reduxjs/toolkit";
import { approveOrRejectPurchaseRequest, getPurchaseRequestById, getStudentPurchasenRequests } from "./purchaseRequestService";

const initialState = {
  purchaseRequests: {
    isDataLoading: null,
    pageCount: 0,
    data: [],
    success: null,
    message: null,
  },
  selectedRequest: {
    isDataLoading: null,
    isDataLoaded: null,
    message: null,
    selectedRequest: null,
    success: null,
  }, 
  approveOrRejectRequest: {
    isDataLoading: null,
    isDataLoaded: null,
    message: null,
    success: null,
  },
};

const purchaseRequests = createSlice({
  name: "purchaseRequest",
  initialState,
  reducers: {
    clearMessages: (state) => {
      state.approveOrRejectRequest.message = null;
      state.approveOrRejectRequest.success = null;
    },
  },
  extraReducers: (builder) => {

    builder.addCase(getStudentPurchasenRequests.pending, (state) => {
      state.purchaseRequests = {
        ...initialState.purchaseRequests,
        isDataLoading: true,
        success: null,
      };
    });

    builder.addCase(getStudentPurchasenRequests.rejected, (state, action) => {
      state.purchaseRequests = {
        ...initialState.purchaseRequests,
        isDataLoading: false,
        message: action.payload || "Error occurred while getting purchase requests",
        success: false,
      };
    });

    builder.addCase(getStudentPurchasenRequests.fulfilled, (state, action) => {
      state.purchaseRequests = {
        ...initialState.purchaseRequests,
        isDataLoading: false,
        pageCount: action.payload.pageCount || 0,
        data: action.payload.data,
        success: true,
        message: action.payload.message
      };
    });

     builder.addCase(getPurchaseRequestById.pending, (state) => {
      state.selectedRequest = {
        ...initialState.selectedRequest,
        isDataLoading: true,
        isDataLoaded: false,
        message: "Loading",
        success: null,
      };
    });

    builder.addCase(getPurchaseRequestById.rejected, (state, action) => {
      state.selectedRequest = {
        ...initialState.selectedRequest,
        isDataLoading: false,
        isDataLoaded: false,
        message: action.payload || "Error occurred while getting request",
        success: false,
      };
    });

    builder.addCase(getPurchaseRequestById.fulfilled, (state, action) => {
      state.selectedRequest = {
        ...initialState.selectedRequest,
        isDataLoading: false,
        isDataLoaded: true,
        selectedRequest: action.payload,
        success: true,
      };
    });

    builder.addCase(approveOrRejectPurchaseRequest.pending, (state) => {
      state.approveOrRejectRequest = {
        ...initialState.approveOrRejectRequest,
        isDataLoading: true,
        isDataLoaded: false,
        message: "Loading",
        success: null,
      };
    });

    builder.addCase(approveOrRejectPurchaseRequest.rejected, (state, action) => {
      state.approveOrRejectRequest = {
        ...initialState.approveOrRejectRequest,
        isDataLoading: false,
        isDataLoaded: false,
        message: action.payload.message || "Error occurred while updating request status",
        success: false,
      };
    });

    builder.addCase(approveOrRejectPurchaseRequest.fulfilled, (state, action) => {
      state.approveOrRejectRequest = {
        ...initialState.approveOrRejectRequest,
        isDataLoading: false,
        isDataLoaded: true,
        message: action.payload.message,
        success: action.payload.success,
      };
    });
  },
});

export const { setSelectedRequest, clearSelectedRequest, clearMessages  } = purchaseRequests.actions;

export default purchaseRequests.reducer;